export enum DrillsActionType {
  Perform = 'Perform',
  Postpone = 'Postpone',
  Update = 'Update',
  Create = 'Create',
  Legacy = 'Legacy',
}
